import { render, staticRenderFns } from "./ErrorSSOLanding.vue?vue&type=template&id=57f523d2&scoped=true"
import script from "./ErrorSSOLanding.vue?vue&type=script&lang=js"
export * from "./ErrorSSOLanding.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57f523d2",
  null
  
)

export default component.exports